module.exports = __webpack_public_path__ + "static/media/copyIcon.3f3a079e.svg";